import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a0ff59b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "成都康威文化传播有限公司", -1));
const _hoisted_3 = {
  class: "header-top"
};
const _hoisted_4 = {
  class: "header-left"
};
const _hoisted_5 = {
  key: 0,
  class: "header-right"
};
const _hoisted_6 = {
  key: 1,
  class: "header-right"
};
import { RouterLink } from "vue-router";
import { reactive, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      account: null
    });
    onMounted(() => {
      var _JSON$parse;
      const User = window.localStorage.getItem('user');
      data.account = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.account;
    });
    const quit = () => {
      window.localStorage.clear();
      location.reload();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(RouterLink), {
        to: "/"
      }, {
        default: _withCtx(() => [_createTextVNode("首页")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/system"
      }, {
        default: _withCtx(() => [_createTextVNode("自审制度")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/recharge"
      }, {
        default: _withCtx(() => [_createTextVNode("充值中心")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/refund"
      }, {
        default: _withCtx(() => [_createTextVNode("退款说明")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/agreement"
      }, {
        default: _withCtx(() => [_createTextVNode("用户协议")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/privacy"
      }, {
        default: _withCtx(() => [_createTextVNode("隐私政策")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/minority"
      }, {
        default: _withCtx(() => [_createTextVNode("未成年人隐私保护政策")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/dispute"
      }, {
        default: _withCtx(() => [_createTextVNode("纠纷处理")]),
        _: 1
      })]), data.account ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(data.account), 1), _createTextVNode(" ， "), _createElementVNode("span", {
        style: {
          "color": "#a06466"
        },
        onClick: quit
      }, "退出")])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(RouterLink), {
        to: "/login",
        style: {
          "color": "#64AA54"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("登录")]),
        _: 1
      }), _createTextVNode(" ｜ "), _createVNode(_unref(RouterLink), {
        to: "/register"
      }, {
        default: _withCtx(() => [_createTextVNode("注册")]),
        _: 1
      })]))])]);
    };
  }
});